


















































































































import { Meta } from '@/store/meta'
import { Component, Vue } from 'vue-property-decorator'
import { Server } from '@/store/server'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class Rooms extends Vue {
  loading = false
  copiedUuid = ''

  get isLoading() {
    return this.loading
  }

  get isViewReady() {
    return this.server.roomsData.rooms.length > 0
  }

  get total() {
    // NOTE: listing.total は partner フィルタ前の合計、rooms はフィルタ後の配列なので
    // ページ表示上のずれが出る場合がある。API 側 quirk のため本画面では触らない。
    return this.server.roomsData.listing.total
  }

  get perPage() {
    return this.server.roomsData.listing.limit
  }

  async mounted() {
    // 法人は API 契約上サービス指定 (X-Channel-User) が必要なので当画面では叩かない。
    // BOCCOチャンネル → サービス詳細から確認する導線に案内する。
    if (this.isBusiness) return

    this.loading = true
    try {
      await this.server.getRooms({})
    } catch (e) {
      // interceptor 側で 401/429 は処理済み。それ以外は空表示に倒す
      return
    } finally {
      this.loading = false
    }
  }

  get meta() {
    return getModule(Meta)
  }

  get server() {
    return getModule(Server)
  }

  get isBusiness() {
    return this.meta.plan !== 'free'
  }

  get roomEntries() {
    return this.server.roomsData.rooms
  }

  detailLink(uuid: string) {
    this.$router.push({ path: '/rooms/' + uuid })
  }

  async copyUuid(uuid: string) {
    try {
      await navigator.clipboard.writeText(uuid)
      this.copiedUuid = uuid
      setTimeout(() => {
        if (this.copiedUuid === uuid) this.copiedUuid = ''
      }, 1500)
    } catch (e) {
      console.warn('clipboard copy failed', e)
    }
  }

  async onPageChanged(page: number) {
    const index = page - 1
    this.loading = true
    try {
      await this.server.getRooms({ offset: index * this.perPage })
    } finally {
      this.loading = false
    }
  }
}
